<template>
  <div class="nav">
    <!-- <img @click="toggleNav()" v-show="!isNavShow" class="nav-hidden-toggle-img" src="./img/nav_show.png" alt="" />
    <img @click="toggleNav()" v-show="isNavShow" class="nav-show-toggle-img" src="./img/nav_hidden.png" alt="" /> -->
    <div class="nav-hidden" v-show="!isNavShow">
      <!-- <router-link to="/user-center/focus" class="nav-hidden-list">
        <img src="./img/subscribe.png" alt="" />
        <div class="nav-hidden-list-text">关注</div>
      </router-link> -->
      <div
        class="nav-hidden-list"
        @click="
          changeCategoryShow({ firstId: 0, secondId: 0, name: '全部直播' })
        "
        :class="navCategory.firstId === 0 ? 'nav-hidden-active' : ''"
      >
        <img
          :src="
            navCategory.firstId === 0
              ? require('@/assets/live/all_active.png')
              : require('@/assets/live/all.png')
          "
          alt=""
        />
        <div class="nav-hidden-list-text">{{ $t("pc.all") }}</div>
      </div>
      <!-- <router-link to="/user-center/focus" class="nav-hidden-list">
        <img src="./img/subscribe.png" alt="" />
        <div class="nav-hidden-list-text">赛程</div>
      </router-link> -->
      <div
        v-for="item in liveMenusCategory"
        :key="item.name"
        @click="
          changeCategoryShow({ firstId: item.id, secondId: 0, name: item.name })
        "
        class="nav-hidden-list"
        :class="navCategory.name === item.name ? 'nav-hidden-active' : ''"
      >
        <img :src="item.logo" v-show="navCategory.firstId !== item.id" alt="" />
        <img
          :src="item.logo_sel ? item.logo_sel : require('./img/sport_on.png')"
          v-show="navCategory.firstId === item.id"
          alt=""
        />
        <div class="nav-hidden-list-text">{{ item.name }}</div>
      </div>
      <div @click="startLive()" class="go-live">
        <img src="./img/live.png" alt="" />
        <div class="go-live-text">开播</div>
      </div>

      <!-- <router-link to="/download" target="_blank" class="download-hide nav-hidden-list flex-column flex-middle-only">
        <img style="margin-bottom: 10px" src="./img/download-app.png" alt="" />
        下载
      </router-link> -->
    </div>
    <!-- <div class="nav-show" v-show="isNavShow">
      <div class="nav-show-list">
        <router-link to="/user-center/focus" class="show-list-title">
          <img src="./img/subscribe.png" v-show="navCategory.name != 0" alt="" />
          <img src="./img/subscribe_on.png" v-show="navCategory.name == 0" alt="" />
          <div class="show-list-text">我的关注</div>
        </router-link>
        <div class="show-list-title" @click="changeCategoryShow({ firstId: 0, secondId: 0, name: '全部直播' })" :class="navCategory.name == '全部直播' ? 'nav-hidden-active' : ''">
          <img src="./img/live.png" v-show="navCategory.name != '全部直播'" alt="" />
          <img src="./img/live_on.png" v-show="navCategory.name == '全部直播'" alt="" />
          <div class="show-list-text">全部直播</div>
        </div>

        <div class="show-list-content" v-for="items of liveMenusCategory" :key="items.name">
          <div class="content-margin" @click="changeCategoryShow({ firstId: items.id, secondId: 0, name: items.name })" :class="navCategory.firstId === items.id ? 'nav-hidden-active' : ''">
            <div class="show-list-title content-margin">
                           <img :src="items.logo ? items.logo : require('./img/sport.png')" v-show="navCategory.firstId !== items.id" alt="" />
                           <img :src="items.logo2 ? items.logo2 : require('./img/sport_on.png')" v-show="navCategory.firstId === items.id" alt="" />
              <img :src="navCategory.firstId === items.id ? items.logo_sel : items.logo" alt="logo" />
              <div class="show-list-text">{{ items.name }}</div>
            </div>
            <div class="show-list-items">
              <div
                v-for="item of items.second_category"
                class="items-item"
                :class="navCategory.secondId === item.id ? 'item-active' : ''"
                :key="item.name"
                @click.stop="changeCategoryShow({ firstId: items.id, secondId: item.id, name: item.name })"
              >
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="nav-btn flex-column flex-middle">
        <qriously class="qrcode flex-middle" :value="$store.state.appConfig.h5_domain ? $store.state.appConfig.h5_domain + 'download' : ''" :size="115" />
        <h3 class="download-text">下载猎鹰直播APP</h3>
        <p class="download-dec">精彩看不停</p>

        <router-link to="/download" target="_blank" class="btn flex-middle">
          <img src="./img/download-app.png" alt="" />
          下载APP
        </router-link>
      </div>
    </div> -->
    <start-live-set
      v-if="isShowLiveSet"
      :isShow.sync="isShowLiveSet"
      @closeDialog="closeDialog"
    ></start-live-set>
  </div>
</template>

<script>
import { post } from "../../util/http";
import { mapMutations, mapState } from "vuex";
import StartLiveSet from "@/components/start-live-set/start-live-set";

export default {
  components: {
    StartLiveSet,
  },
  inject: ["reload"],
  data() {
    return {
      navHidden: 1,
      navHiddenList: [
        {
          text: "订阅",
          goto: "/user-center/focus",
          img1: require("./img/subscribe.png"),
          img2: require("./img/subscribe_on.png"),
        },
        {
          text: "直播",
          goto: "/liveMatches",
          img1: require("./img/live.png"),
          img2: require("./img/live_on.png"),
        },
        {
          text: "赛事",
          goto: "/schedule",
          img1: require("./img/match.png"),
          img2: require("./img/match_on.png"),
        },
      ],
      // isNavShow: true,
      isMatchMore: true,
      liveMenusMatch: [],
      liveMenusLive: [],
      liveMenusCategory: [],
      changeItem: null,
      changeItemS: null,
      isShowLiveSet: false,
    };
  },
  computed: {
    ...mapState(["navCategory", "isNavShow", "userInfo"]),
  },
  async mounted() {
    await this.getLiveMenus();
    // if (this.userInfo.id) {
    //   this.getAuthInfo();
    // }
  },
  methods: {
    ...mapMutations(["changeNavCategoryName", "toggleNavShow"]),

    // async getAuthInfo() {
    //   const {
    //     data: { data, status, msg },
    //   } = await post({
    //     url: "/api/auth/getAuthInfo",
    //   });
    //   if (status == 0) {
    //     this.isAnchor = data.status;
    //   }
    // },

    async getLiveMenus() {
      const {
        data: { data },
      } = await post({ url: "/api/live/liveMenus" });
      this.liveMenusMatch = data.match_data;
      this.liveMenusLive = data.live_data;
      this.liveMenusCategory = data.category_data;
      this.$emit("categoryData", this.liveMenusCategory);
    },

    changeCategoryShow(obj) {
      this.changeNavCategoryName(obj);
      if (this.$route.path !== "/liveMatches") {
        this.$router.push("/liveMatches");
      }
      this.$emit("changeCat");
    },

    toggleNav() {
      this.toggleNavShow();
    },

    changeCategory(index) {
      this.navCategory = index;
    },

    closeDialog() {
      this.isShowLiveSet = false;
    },

    // startLive() {
    //   post({ url: "/api/user/checkAnchorStatus" })
    //     .then(({ data: { data } }) => {
    //       let { is_anchor = 0, is_live = 0 } = data;
    //       if (is_anchor == 0) {
    //         this.$router.push("/user-center/apply-anchor");
    //         return;
    //       }
    //       if (is_live == 1) {
    //         this.$router.push("/liveMatchesTwo/" + this.userInfo.id);
    //         this.reload();
    //       } else {
    //         this.isShowLiveSet = true;
    //       }
    //     })
    //     .catch((err) => console.log("err: ", err));
    // },
  },
};
</script>

<style lang="scss" scoped>
.nav {
  position: sticky;
  top: 0.66rem;
  height: 100vh;
}
.qrcode {
  width: 120px;
  height: 120px;
  background: #fff;
  border-radius: 4px;
}
.nav-hidden-toggle-img {
  width: 0.11rem;
  position: absolute;
  top: 45%;
  left: 0.44rem;
  z-index: 1;
  cursor: pointer;
}

.download-hide {
  width: 90%;
  position: absolute;
  bottom: 1rem;
  box-shadow: inset 0px 1px 0px rgba(0, 0, 0, 0.2);
  padding-top: 0.2rem;
}

.nav-show-toggle-img {
  width: 0.11rem;
  position: absolute;
  top: 46%;
  left: 2.41rem;
  z-index: 1;
  cursor: pointer;
}
.nav-hidden {
  position: relative;
  /* top: -0.02rem; */
  width: 62px;
  height: 100%;
  overflow: scroll;
  background: rgba(0, 0, 38, 1);
  margin-right: 43px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .nav-hidden-list {
    cursor: pointer;
    margin: 0.1rem 0;
    color: rgba(191, 189, 189, 0.8);
    display: flex;
    flex-direction: column;
    align-items: center;
    img {
      width: 0.24rem;
      height: 0.24rem;
    }
    .nav-hidden-list-text {
      margin-top: 3px;
      font-size: 12px;
      text-align: center;
    }
  }
  .go-live {
    position: absolute;
    bottom: 0.2rem;
    color: #fff;
    cursor: pointer;
    img {
      width: 0.24rem;
      height: 0.24rem;
    }
  }
  .nav-hidden-active {
    color: #fff;
  }
}
.nav-show {
  position: relative;
  top: 0;
  width: 2.42rem;
  height: 100%;
  overflow: scroll;
  background-color: #2f3035;
  margin-right: 0.34rem;
  display: flex;
  flex-direction: column;
  color: #fff;
  padding-left: 0.1rem;
  padding-bottom: 0.4rem;
  // align-items: center;

  .show-list-title {
    display: flex;
    align-items: center;
    margin: 0.2rem 0;
    font-size: 0.16rem;
    cursor: pointer;
    img {
      width: 0.24rem;
      height: 0.24rem;
    }
    .show-list-text {
      margin-left: 0.05rem;
    }
    .show-list-more {
      cursor: pointer;
      width: 0.3rem;
      margin-left: 0.95rem;
      display: flex;
      justify-content: center;
      img {
        width: 0.16rem;
        height: 0.16rem;
      }
    }
  }
  .match-more {
    padding: 0.1rem;
    width: 2.1rem;
    background: rgba(102, 102, 102, 0.2);
    border-radius: 0.05rem;
    color: #999;
    .match-list {
      margin-bottom: 0.18rem;
      cursor: pointer;
      .up {
        display: flex;
        align-items: center;
        font-size: 0.14rem;
        img {
          margin-right: 0.05rem;
          width: 0.12rem;
        }
      }
      .down {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 0.05rem;
        .score {
          margin: 0 0.03rem;
          min-width: 0.18rem;
          height: 0.2rem;
          display: flex;
          align-items: center;
          justify-content: center;
          background: rgba(102, 102, 102, 0.3);
          border-radius: 0.02rem;
        }
      }
    }
    .more {
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      img {
        width: 0.14rem;
        height: 0.14rem;
      }
    }
  }
  .content-margin {
    margin-bottom: 0.1rem;
  }
  .show-list-item-logo {
    display: flex;
    align-items: center;
    .item {
      // height: 0.4rem;
      // width: 0.4rem;
      // border-radius: 0.04rem;
      // background-color: rgba(0, 0, 0, 0.2);
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 0.16rem;
      cursor: pointer;
      img {
        width: 0.4rem;
        height: 0.4rem;
        border-radius: 50%;
      }
    }
  }
  .show-list-items {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .items-item {
      width: 0.68rem;
      height: 0.28rem;
      background: rgba(102, 102, 102, 0.2);
      border-radius: 2px 0px 0px 2px;
      margin-right: 0.07rem;
      margin-bottom: 0.1rem;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #f4f5f8;
      cursor: pointer;
    }
    .item-active {
      color: #02a8a2;
    }
  }
  .nav-ad {
    position: relative;
    margin-top: 0.2rem;
    .nav-ad-close {
      position: absolute;
      top: 0;
      right: 0.19rem;
      cursor: pointer;
      width: 0.2rem;
      height: 0.2rem;
    }
    .nav-ad-text {
      position: absolute;
      top: 0;
      left: 0;
      width: 0.6rem;
      height: 0.18rem;
      background-color: #2f3035;
      font-size: 0.12rem;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .nav-ad-bg {
      width: 2.13rem;
      height: 0.69rem;
      border-radius: 0.05rem;
      cursor: pointer;
    }
  }
  .nav-btn {
    margin: 0.5rem 0 0 -0.1rem;
    .btn {
      width: 1.8rem;
      height: 0.48rem;
      background: #02a8a2;
      border-radius: 4px;
      cursor: pointer;
      img {
        height: 0.14rem;
        margin-right: 0.05rem;
      }
    }
  }

  .download-text {
    margin: 0.16rem 0 0.06rem 0;
    font-weight: 500;
    font-size: 0.15rem;
    line-height: 0.21rem;
    background: linear-gradient(
      360deg,
      #ffffff 11.9%,
      rgba(255, 255, 255, 0.4) 100%
    );
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-fill-color: transparent;
  }

  .download-dec {
    font-size: 0.13rem;
    color: rgba(255, 255, 255, 0.35);
    line-height: 0.2rem;
    margin-bottom: 0.16rem;
  }

  .nav-hidden-active {
    color: #02a8a2;
  }
}
</style>
